import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="regulatory_updates" pageTitle="Actualizaciones regulatorias" pageDescription="Mantente al día con los cambios regulatorios que afectan a farma, dispositivos médicos e IVD — análisis experto de nuevas directrices y legislación." />;

export const Route = createFileRoute("/es/actualizaciones-regulatorias/")({
  head: () => buildRouteHead("/es/actualizaciones-regulatorias"),
  component: ContentListingRoute,
});

